
import { mapState } from 'vuex'
import theserver from '~/components/company/v2/theserver.vue'
export default {
  components: {
    theserver
  },
  inject: ['company_detail'],
  props: {
    softval: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      authenticationState:false,
      detail: {},
      servers: []
    }
  },
    computed: {
    ...mapState({
      isMobile: 'mobile'
    }),
    isZh() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-cn' || code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return true
      } else {
        return false
      }
    }
   },
  created() {
  },
  mounted() {
    console.log('MT4/5弹窗', this.detail)
  },
  methods: {
    openIpDialog(item) {
      console.log('触发2');
      this.$emit('opendialog',item)
    },
    close(){
      document.body.style.overflow = 'auto'
      this.authenticationState = false
      this.myChart2.clear()
      this.detail = {}
    },
    open() {
      // 打开弹框
      console.log('打开的softval', this.softval)
      this.getDetail()
    },
    async getDetail() {
      const that = this
      console.log('that.detail.main.companyId: ', that.detail);
      console.log('that.softval.softwareId: ', that.softval?.softwareId);
      console.log('that.softval: ', that.softval);

      const ret = await that.$api.common
      .CV3({
        traderCode: '',
        softwareId: that.softval?.softwareId
      }, {
        Routes: 'wikifxagg$mt4_mt5_appraise_v2'
      })
      const res = ret?.wikifxagg?.mt4_mt5_appraise_v2?.data
      console.log('res: ', res)
      if(res){
        this.detail = res
        this.authenticationState = true
        this.servers = this.softval?.softwareType == 1 ? res?.serverList?.mT4_Servers :  res?.serverList?.mT5_Servers
        this.showMap()
        document.body.style.overflow = 'hidden'
      }
    },
    showMap() {
      if(this.isScriptLoaded('https://resources1.interface003.com/web20/word.js')){
        console.log('有');
        setTimeout(()=>{
            this.getData(this.detail?.globalLocation?.previewLocations)
          },100)
      } else {
        console.log('否');
        window.echarts = this.$echarts
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.src = 'https://resources1.interface003.com/web20/word.js'
        document.body.insertBefore(script, document.body.firstChild)
        script.onload = () => {
          setTimeout(()=>{
            this.getData(this.detail?.globalLocation?.previewLocations)
          },100)
        }
      }
    },
    isScriptLoaded(src) {
      const scripts = document.getElementsByTagName('script');
      for (let i = 0; i < scripts.length; i++) {
          if (scripts[i].getAttribute('src') == src) {
              return true;
          }
      }
      return false;
    },
    getData (country = []) {
      const worldData = [
        { TwoCode: 'AF', Name: 'Afghanistan' },
        { TwoCode: 'AL', Name: 'Albania' },
        { TwoCode: 'AQ', Name: 'Antarctica' },
        { TwoCode: 'DZ', Name: 'Algeria' },
        { TwoCode: 'AS', Name: 'American Samoa' },
        { TwoCode: 'AD', Name: 'Andorra' },
        { TwoCode: 'AO', Name: 'Angola' },
        { TwoCode: 'AZ', Name: 'Azerbaijan' },
        { TwoCode: 'AR', Name: 'Argentina' },
        { TwoCode: 'AU', Name: 'Australia' },
        { TwoCode: 'AT', Name: 'Austria' },
        { TwoCode: 'BS', Name: 'Bahamas' },
        { TwoCode: 'BH', Name: 'Bahrain' },
        { TwoCode: 'AM', Name: 'Armenia' },
        { TwoCode: 'BB', Name: 'Barbados' },
        { TwoCode: 'BE', Name: 'Belgium' },
        { TwoCode: 'BM', Name: 'Bermuda' },
        { TwoCode: 'BT', Name: 'Bhutan' },
        { TwoCode: 'BO', Name: 'Bolivia' },
        { TwoCode: 'BW', Name: 'Botswana' },
        { TwoCode: 'BR', Name: 'Brazil' },
        { TwoCode: 'BZ', Name: 'Belize' },
        { TwoCode: 'VG', Name: 'The Virgin Islands' },
        { TwoCode: 'BN', Name: 'Brunei' },
        { TwoCode: 'BG', Name: 'Bulgaria' },
        { TwoCode: 'MM', Name: 'Myanmar' },
        { TwoCode: 'BI', Name: 'Burundi' },
        { TwoCode: 'BY', Name: 'Belarus' },
        { TwoCode: 'KH', Name: 'Cambodia' },
        { TwoCode: 'CM', Name: 'Cameroon' },
        { TwoCode: 'CA', Name: 'Canada' },
        { TwoCode: 'CV', Name: 'Cape Verde' },
        { TwoCode: 'LK', Name: 'Sri Lanka' },
        { TwoCode: 'TD', Name: 'Chad' },
        { TwoCode: 'CL', Name: 'Chile' },
        { TwoCode: 'CN', Name: 'China' },
        { TwoCode: 'TW', Name: 'China Taiwan' },
        { TwoCode: 'CX', Name: 'Christmas Island' },
        { TwoCode: 'CC', Name: 'Cocos Islands' },
        { TwoCode: 'CO', Name: 'Colombia' },
        { TwoCode: 'KM', Name: 'Comoros' },
        { TwoCode: 'YT', Name: 'Mayotte' },
        { TwoCode: 'CK', Name: 'Island' },
        { TwoCode: 'CR', Name: 'Costa Rica' },
        { TwoCode: 'HR', Name: 'Croatia' },
        { TwoCode: 'CU', Name: 'Cuba' },
        { TwoCode: 'BJ', Name: 'Benin' },
        { TwoCode: 'DK', Name: 'Denmark' },
        { TwoCode: 'DM', Name: 'Dominic' },
        { TwoCode: 'EC', Name: 'Ecuador' },
        { TwoCode: 'ET', Name: 'Ethiopia' },
        { TwoCode: 'ER', Name: 'Eritrea' },
        { TwoCode: 'EE', Name: 'Estonia' },
        { TwoCode: 'FI', Name: 'Finland' },
        { TwoCode: 'FR', Name: 'France' },
        { TwoCode: 'DJ', Name: 'Djibouti' },
        { TwoCode: 'GA', Name: 'Gabon' },
        { TwoCode: 'GE', Name: 'Georgia' },
        { TwoCode: 'GM', Name: 'Gambia' },
        { TwoCode: 'PS', Name: 'Palestine' },
        { TwoCode: 'DE', Name: 'Germany' },
        { TwoCode: 'GH', Name: 'Ghana' },
        { TwoCode: 'GI', Name: 'Gibraltar' },
        { TwoCode: 'KI', Name: 'Kiribati' },
        { TwoCode: 'GR', Name: 'Greece' },
        { TwoCode: 'GL', Name: 'Greenland' },
        { TwoCode: 'GD', Name: 'Grenada' },
        { TwoCode: 'GP', Name: 'Guadeloupe' },
        { TwoCode: 'GU', Name: 'Guam' },
        { TwoCode: 'GT', Name: 'Guatemala' },
        { TwoCode: 'GN', Name: 'Guinea' },
        { TwoCode: 'GY', Name: 'Guyana' },
        { TwoCode: 'HT', Name: 'Haiti' },
        { TwoCode: 'VA', Name: 'Vatican' },
        { TwoCode: 'HN', Name: 'Honduras' },
        { TwoCode: 'HK', Name: 'China Hong Kong' },
        { TwoCode: 'HU', Name: 'Hungary' },
        { TwoCode: 'IS', Name: 'Iceland' },
        { TwoCode: 'IN', Name: 'India' },
        { TwoCode: 'ID', Name: 'Indonesia' },
        { TwoCode: 'IR', Name: 'Iran' },
        { TwoCode: 'IQ', Name: 'Iraq' },
        { TwoCode: 'IE', Name: 'Ireland' },
        { TwoCode: 'IL', Name: 'Israel' },
        { TwoCode: 'IT', Name: 'Italy' },
        { TwoCode: 'JM', Name: 'Jamaica' },
        { TwoCode: 'JP', Name: 'Japan' },
        { TwoCode: 'KZ', Name: 'Kazakhstan' },
        { TwoCode: 'JO', Name: 'Jordan' },
        { TwoCode: 'KE', Name: 'Kenya' },
        { TwoCode: 'KR', Name: 'Korea' },
        { TwoCode: 'KW', Name: 'Kuwait' },
        { TwoCode: 'KG', Name: 'Kyrgyzstan' },
        { TwoCode: 'LB', Name: 'Lebanon' },
        { TwoCode: 'LS', Name: 'Lesotho' },
        { TwoCode: 'LV', Name: 'Latvia' },
        { TwoCode: 'LR', Name: 'Liberia' },
        { TwoCode: 'LY', Name: 'Libya' },
        { TwoCode: 'LI', Name: 'Liechtenstein' },
        { TwoCode: 'LT', Name: 'Lithuania' },
        { TwoCode: 'LU', Name: 'Luxembourg' },
        { TwoCode: 'MO', Name: 'Macao' },
        { TwoCode: 'MG', Name: 'Madagascar' },
        { TwoCode: 'MW', Name: 'Malawi' },
        { TwoCode: 'MY', Name: 'Malaysia' },
        { TwoCode: 'MV', Name: 'Maldives' },
        { TwoCode: 'ML', Name: 'Mali' },
        { TwoCode: 'MT', Name: 'Malta' },
        { TwoCode: 'MQ', Name: 'Martinique' },
        { TwoCode: 'MR', Name: 'Mauritania' },
        { TwoCode: 'MU', Name: 'Mauritius' },
        { TwoCode: 'MX', Name: 'Mexico' },
        { TwoCode: 'MC', Name: 'Monaco' },
        { TwoCode: 'MN', Name: 'Mongolia' },
        { TwoCode: 'MD', Name: 'Moldova' },
        { TwoCode: 'ME', Name: 'Montenegro' },
        { TwoCode: 'MA', Name: 'Morocco' },
        { TwoCode: 'MZ', Name: 'Mozambique' },
        { TwoCode: 'OM', Name: 'Oman' },
        { TwoCode: 'NA', Name: 'Namibia' },
        { TwoCode: 'NR', Name: 'Nauru' },
        { TwoCode: 'NP', Name: 'Nepal' },
        { TwoCode: 'NL', Name: 'Netherlands' },
        { TwoCode: 'AW', Name: 'Aruba' },
        { TwoCode: 'NC', Name: 'New Caledonia' },
        { TwoCode: 'VU', Name: 'Vanuatu' },
        { TwoCode: 'NZ', Name: 'New Zealand' },
        { TwoCode: 'NI', Name: 'Nicaragua' },
        { TwoCode: 'NE', Name: 'Niger' },
        { TwoCode: 'NG', Name: 'Nigeria' },
        { TwoCode: 'NU', Name: 'Niue' },
        { TwoCode: 'NF', Name: 'Norfolk Island' },
        { TwoCode: 'NO', Name: 'Norway' },
        { TwoCode: 'MH', Name: 'Marshall Islands' },
        { TwoCode: 'PW', Name: 'Palau' },
        { TwoCode: 'PK', Name: 'Pakistan' },
        { TwoCode: 'PA', Name: 'Panama' },
        { TwoCode: 'PG', Name: 'Papua New Guinea' },
        { TwoCode: 'PY', Name: 'Paraguay' },
        { TwoCode: 'PE', Name: 'Peru' },
        { TwoCode: 'PH', Name: 'Philippines' },
        { TwoCode: 'PN', Name: 'Pitcairn Islands' },
        { TwoCode: 'PL', Name: 'Poland' },
        { TwoCode: 'PT', Name: 'Portugal' },
        { TwoCode: 'GW', Name: 'Guinea-Bissau' },
        { TwoCode: 'QA', Name: 'Qatar' },
        { TwoCode: 'RE', Name: 'Reunion' },
        { TwoCode: 'RO', Name: 'Romania' },
        { TwoCode: 'RU', Name: 'Russia' },
        { TwoCode: 'RW', Name: 'Rwanda' },
        { TwoCode: 'BL', Name: 'St. Barthelemy' },
        { TwoCode: 'KN', Name: 'Saint Kitts and Nevis' },
        { TwoCode: 'AI', Name: 'Anguilla' },
        { TwoCode: 'LC', Name: 'Saint Lucia' },
        { TwoCode: 'SM', Name: 'San Marino' },
        { TwoCode: 'SA', Name: 'Saudi Arabia' },
        { TwoCode: 'SN', Name: 'Senegal' },
        { TwoCode: 'RS', Name: 'Serbia' },
        { TwoCode: 'SC', Name: 'Seychelles' },
        { TwoCode: 'SL', Name: 'Sierra Leone' },
        { TwoCode: 'SG', Name: 'Singapore' },
        { TwoCode: 'SK', Name: 'Slovakia' },
        { TwoCode: 'VN', Name: 'Vietnam' },
        { TwoCode: 'SI', Name: 'Slovenia' },
        { TwoCode: 'SO', Name: 'Somalia' },
        { TwoCode: 'ZA', Name: 'South Africa' },
        { TwoCode: 'ZW', Name: 'Zimbabwe' },
        { TwoCode: 'ES', Name: 'Spain' },
        { TwoCode: 'SD', Name: 'Sudan' },
        { TwoCode: 'SR', Name: 'Suriname' },
        { TwoCode: 'SZ', Name: 'Swaziland' },
        { TwoCode: 'SE', Name: 'Sweden' },
        { TwoCode: 'CH', Name: 'Switzerland' },
        { TwoCode: 'SY', Name: 'Syria' },
        { TwoCode: 'TJ', Name: 'Tajikistan' },
        { TwoCode: 'TH', Name: 'Thailand' },
        { TwoCode: 'TG', Name: 'Togo' },
        { TwoCode: 'TK', Name: 'Tokelau' },
        { TwoCode: 'TO', Name: 'Tonga' },
        { TwoCode: 'TT', Name: 'Trinidad and Tobago' },
        { TwoCode: 'AE', Name: 'United Arab Emirates' },
        { TwoCode: 'TN', Name: 'Tunisia' },
        { TwoCode: 'TR', Name: 'Turkey' },
        { TwoCode: 'TM', Name: 'Turkmenistan' },
        { TwoCode: 'TV', Name: 'Tuvalu' },
        { TwoCode: 'UG', Name: 'Uganda' },
        { TwoCode: 'UA', Name: 'Ukraine' },
        { TwoCode: 'MK', Name: 'Macedonia' },
        { TwoCode: 'EG', Name: 'Egypt' },
        { TwoCode: 'UK', Name: 'United Kingdom' },
        { TwoCode: 'JE', Name: 'Jersey' },
        { TwoCode: 'IM', Name: 'Isle of Man' },
        { TwoCode: 'TZ', Name: 'Tanzania' },
        { TwoCode: 'US', Name: 'United States' },
        { TwoCode: 'BF', Name: 'Burkina Faso' },
        { TwoCode: 'UY', Name: 'Uruguay' },
        { TwoCode: 'UZ', Name: 'Uzbekistan' },
        { TwoCode: 'VE', Name: 'Venezuela' },
        { TwoCode: 'WF', Name: 'Wallis and Futuna' },
        { TwoCode: 'WS', Name: 'Samoa' },
        { TwoCode: 'YE', Name: 'Yemen' },
        { TwoCode: 'ZM', Name: 'Zambia' },
        { TwoCode: 'EH', Name: 'W. Sahara' },
        { TwoCode: 'AX', Name: 'Aland' },
        { TwoCode: 'GF', Name: 'Fr. S. Antarctic Lands' },
        { TwoCode: 'AG', Name: 'Antigua and Barb.' },
        { TwoCode: 'BD', Name: 'Bangladesh' },
        { TwoCode: 'BA', Name: 'Bosnia and Herz.' },
        { TwoCode: 'CF', Name: 'Central African Rep.' },
          { TwoCode: 'CI', Name: "Côte d'Ivoire" }, // eslint-disable-line
        { TwoCode: 'CD', Name: 'Dem. Rep. Congo' },
        { TwoCode: 'CG', Name: 'Congo' },
        { TwoCode: 'KY', Name: 'Cayman Is.' },
        { TwoCode: 'CY', Name: 'N. Cyprus' },
        { TwoCode: 'CZ', Name: 'Czech Rep.' },
        { TwoCode: 'DO', Name: 'Dominican Rep.' },
        { TwoCode: 'FJ', Name: 'Fiji' },
        { TwoCode: 'FK', Name: 'Falkland Is.' },
        { TwoCode: 'LA', Name: 'Lao PDR' },
        { TwoCode: 'FO', Name: 'Faeroe Is.' },
        { TwoCode: 'FM', Name: 'Micronesia' },
        { TwoCode: 'GQ', Name: 'Eq. Guinea' },
        { TwoCode: 'HM', Name: 'Heard I. and McDonald Is.' },
        { TwoCode: 'IO', Name: 'Br. Indian Ocean Ter.' },
        { TwoCode: 'MP', Name: 'N. Mariana Is.' },
        { TwoCode: 'MS', Name: 'Montserrat' },
        { TwoCode: 'KP', Name: 'Dem. Rep. Korea' },
        { TwoCode: 'PF', Name: 'Fr. Polynesia' },
        { TwoCode: 'SS', Name: 'S. Sudan' },
        { TwoCode: 'GS', Name: 'S. Geo. and S. Sandw. Is.' },
        { TwoCode: 'SH', Name: 'Saint Helena' },
        { TwoCode: 'SB', Name: 'Solomon Is.' },
        { TwoCode: 'SV', Name: 'El Salvador' },
        { TwoCode: 'PM', Name: 'St. Pierre and Miquelon' },
        { TwoCode: 'ST', Name: 'São Tomé and Principe' },
        { TwoCode: 'TC', Name: 'Turks and Caicos Is.' },
        { TwoCode: 'TL', Name: 'Timor-Leste' },
        { TwoCode: 'VC', Name: 'St. Vin. and Gren.' },
        { TwoCode: 'VI', Name: 'U.S. Virgin Is.' }
      ]
      const datalist = []
      worldData.forEach((item) => {
        const selData = worldData.find((p) => {
          return p.countrycode == item.TwoCode
        })
        if (selData) {
          datalist.push({
            value: selData.score,
            name: item.Name
          })
        } else {
          datalist.push({
            value: -1,
            name: item.Name
          })
        }
      })
      const info = []
      if (country.length > 0) {
        country.forEach((item) => {
          info.push({
            value: [item.latitude, item.longitude],
            symbolSize :15,
            rippleEffect: {
              scale: 0.8
            },
            symbol: item.velocity == 1 ?'image://https://resources1.interface003.com/appuni/images/green.gif': item.velocity == 2 ? 'image://https://resources1.interface003.com/appuni/images/yellow.gif':
            'image://https://resources1.interface003.com/appuni/images/red.gif',
          })
        })
      }
      this.loadEcharts(datalist,info)
    },
    loadEcharts(worlddata,scatter) {
      const option = {
        backgroundColor: 'transparent',
        label: {
          show: false
        },
        grid: {
          show: false,
          tooltip: {
            show: false
          }
        },
        select: {
          itemStyle: {
              color: '#fff',
              areaColor: "rgb(81,133,180)",
              emphasis: {
                show: true,
                label: {
                  fontSize: 0,
                }
            },
          },
        },
        geo: {
          map: 'world',
          zoom: 1.2,
          show: true,
          roam: false,
          label: {
            fontSize:0,
            show: false,
            Emphasis: {
              show: false
            }
          },
          itemStyle: {
							borderColor: 'rgba(255, 255, 255, 0.40)',
							borderWidth: 1,
							areaColor: "rgb(81,133,180)",
							color: "rgb(81,133,180)",
              emphasis: {
                  show: false,
                  areaColor: 'rgb(81,133,180)',
                  label: {
                    fontSize: 0,
                  }
                },
						},
        },
        series: [
          {
            label: {
              show: false,
              fontSize: 0,
            },
            name: 'world',
            type: 'map',
            map: 'world',
            animation: false, // 去掉动画效果
            roam: false,
            zoom: 1.2,
            itemStyle: {
							borderColor: 'rgba(255, 255, 255, 0.40)',
							borderWidth: 1,
							areaColor: "rgb(81,133,180)",
							color: "rgb(81,133,180)",
              emphasis: {
                  show: false,
                  areaColor: 'rgb(81,133,180)',
                  label: {
                    fontSize: 0,
                  }
                },
						},
            data: worlddata
          },
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            symbolSize: 300,
            rippleEffect: {
              scale: 1
            },
            data: scatter
          }
        ]
      }
      console.log(this.$refs.mapbox);
      console.log('option: ', option);
      
      const dom2 = document.getElementById("mapbox");
      console.log('dom2: ', dom2);
      const myChart2 = this.$echarts.init(dom2, null, { renderer: 'svg' });
      this.myChart2= myChart2
        myChart2.setOption(option, true);

        // 监听 click 事件
        myChart2.on('click', function (params) {
          console.log('params: ', params);
          if (params.componentType === 'series') {
              // 点击的是地图系列（series）
              let geoCoord = params.value; // 获取点击位置的经纬度数组 [经度, 纬度]
              if(geoCoord == -1) geoCoord = [params.value]
              console.log(geoCoord);
          }
      })
    }
  }
};
